export default __webpack_public_path__ + "static/media/ies_Construlita.613b092c.png";